// Service page content for Student Visa Extension (a further Subclass 500).
// Sourced from docs/research/australian-visa-pathways.md §5.
// COMPLIANCE: we keep the file current and coordinate timing; a registered
// migration agent gives the migration advice and lodges the new Subclass 500.
// Accurate that there is no literal "extension"; no guarantees.

const studentVisaExtension = {
  groupSlug: "student-graduate",
  slug: "student-visa-extension",
  title: "Student Visa Extension",
  eyebrow: "Student & Graduate",
  intro:
    "If your studies will run past your current visa, you will need to keep your student visa current. Australia does not literally extend a student visa: you apply for a new Subclass 500 to continue or progress your studies. We help you time it right so there is no gap.",

  chips: [
    { label: "What it is", value: "A new Subclass 500 application" },
    { label: "When", value: "Before your current visa ends" },
    { label: "Key test", value: "Genuine Student requirement again" },
    { label: "Goal", value: "No gap in your study or status" },
  ],

  whoFor: [
    "Students whose course will finish after their current visa expires.",
    "Students moving from one course or level to the next.",
    "People who want to avoid an unlawful gap between visas.",
  ],

  essentials: [
    {
      title: "It is a new application, not a renewal",
      detail:
        "There is no literal extension. You lodge a fresh Subclass 500, so the full student-visa requirements apply again.",
    },
    {
      title: "Current or continued enrolment",
      detail:
        "You need a Confirmation of Enrolment for the course you are continuing or progressing into.",
    },
    {
      title: "The Genuine Student requirement",
      detail:
        "You must again show a genuine intention to study, with your course progression making sense.",
    },
    {
      title: "Financial capacity and English",
      detail:
        "Current financial-capacity and English requirements apply, just as for the first visa.",
    },
    {
      title: "OSHC for the new period",
      detail:
        "Your health cover must extend to cover the new visa period.",
    },
    {
      title: "Timing matters",
      detail:
        "Lodging before your current visa ends keeps you lawful, usually on a bridging visa while it is processed.",
    },
  ],

  process: [
    {
      title: "Review your timeline",
      detail:
        "We check your course end date against your visa expiry and plan the lodgement window.",
    },
    {
      title: "Confirm enrolment",
      detail:
        "We make sure your Confirmation of Enrolment supports a sensible study progression.",
    },
    {
      title: "Prepare the evidence",
      detail:
        "We help you refresh your financial, English, and Genuine Student evidence.",
    },
    {
      title: "Lodge in time",
      detail:
        "We have your file ready ahead of your current visa ending, and a registered migration agent lodges it so you remain lawful while it is processed.",
    },
    {
      title: "Decision",
      detail:
        "The Department decides. We keep your file current and coordinated, and a registered migration agent responds to any requests from the Department.",
    },
  ],

  faqs: [
    {
      q: "Can I just extend my existing visa?",
      a: "No. Australia does not extend a student visa. You apply for a new Subclass 500 to keep studying, which means the student-visa requirements apply again. We prepare and organise it as a fresh application, and a registered migration agent lodges it.",
    },
    {
      q: "When should I apply?",
      a: "Before your current visa expires. Lodging in time usually means you get a bridging visa to stay lawfully while the new application is processed. We keep the timing organised with you so there is no gap, and a registered migration agent lodges before the deadline.",
    },
    {
      q: "Will my visa history affect a new student visa?",
      a: "Your study record and progression are relevant to the Genuine Student assessment. Sensible, consistent progression helps. A registered migration agent advises on how to present your situation, and we gather and organise the supporting documents.",
    },
    {
      q: "What if I want to change course at the same time?",
      a: "That is common. We coordinate a course change with your new visa application so everything lines up. See our change of course and institution service for more.",
    },
  ],

  related: ["student-500", "change-of-course", "graduate-485"],

  lastVerified: "13 July 2026",
};

export default studentVisaExtension;
